import zenObservable from 'zen-observable';

var Observable = zenObservable;

export default Observable;
export { Observable };
//# sourceMappingURL=bundle.esm.js.map



//////////////////
// WEBPACK FOOTER
// ./~/zen-observable-ts/lib/bundle.esm.js
// module id = 367
// module chunks = 0